import React from "react";

const LoginSide = () => {
  return <img src="./images/bg.jpg" alt="" />;
};

export default LoginSide;
